export default "__VITE_ASSET__5308ca2f__"